import {AutoCompleteService} from 'ionic2-auto-complete';
import { Observable } from 'rxjs/Rx';
import { PointInterest } from './../objects/data-management';
import { Storage } from '@ionic/storage';
import { CallNumber } from '@ionic-native/call-number';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Http, Headers} from '@angular/http';
import {GlobalService} from "./global.config";
import {RealTimeRecord, Group} from "../objects/real-time";
import {createAuthorizationHeader} from "../utils/headers";
import {User} from '../objects/real-time';
import {Events } from 'ionic-angular';
import {
  Subscription
} from "rxjs";


@Injectable()
export class CompleteTestService implements AutoCompleteService {
  labelAttribute = "matricule";
  allGroups: Subscription;

  currentuser:User;
  data:any[] = [];
  vehicules:any[] = [];
  dns:string;
    
    constructor(private http: Http,private storage:Storage,private globalService : GlobalService,public events: Events) {
        this.currentuser=JSON.parse(localStorage.getItem('currentuser'));
      this.dns = globalService.getDns();
      console.log(this.dns);
        
    }


  getResults(keyword:string){

    this.allGroups = this.getAllGroups(keyword).subscribe(groupes => {
      this.data = groupes}
      );
    if(this.vehicules.length == 0){
      this.data.forEach(group => {
      //console.log(group.vehicules);

      this.vehicules.push.apply(this.vehicules, group.vehicules);
      //this.vehicules.concat(group.vehicules);
      //console.log(this.vehicules);
    });
    }
    
    //console.log(this.vehicules);

    this.vehicules = this.vehicules.filter(item => item.matricule.toLowerCase().indexOf(keyword.toLowerCase()) > -1);
      return this.vehicules;

}

getAllGroups(keyword: string): Observable<Group[]> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let parms = "";
        if (!this.currentuser.isRoot) {
            parms = '&id=' + this.currentuser.id;
        }
        console.log(this.dns);
        return this.http.get(this.dns + 'groupes/details?keyword=' + keyword + parms, {headers: headers}).map(res => res.json());       
    }




}




// WEBPACK FOOTER //
// ./src/providers/CompleteTestService.ts